<template lang="pug">
.hover-wrapper(v-show="bookings.length > 0 && !showMenu" :style="{ left: mousePos.x + 'px', top: mousePos.y + 'px' }")
  .ro-wrapper(v-for="b in bookings")
    .color-box(:style="{backgroundColor: getColorCodeFromBooking(b)}")
    .msg {{getNameFromBooking(b)}}
</template>

<script>
import { DateTime } from "luxon";
export default {
  props: {
    showMenu: {
      type: Boolean
    },
    bookingStatus: {
      type: Array
    },
    bookings: {
      type: Array
    },
    mousePos: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0
        }
      }
    }
  },
  computed: {
    commissions() {
      return this.$store.state.commissions.all
    },
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    getColorCodeFromBooking(booking) {
      const status = this.bookingStatus.find(b => b.id === booking.bookingStatusId);
      return status.colorCode;
    },
    getNameFromBooking(booking) {
      
      const status = this.bookingStatus.find(b => b.id === booking.bookingStatusId);
      const commission = this.commissions.find(c => c.id == booking.commissionId);
      
      let modText = "";
      if (status.uuid === 'STATUS_BOOKING_PERSONAL') {
        modText = `${booking.owner.fullName} ${this.formatDate(booking.createdAt)}`;
      } else if (status.uuid === 'STATUS_BOOKING_BLOCKED') {
        modText = `${booking.comment ? booking.comment : ''} ${this.formatDate(booking.createdAt)}`;
      } else if (status.uuid === 'STATUS_BOOKING_INTERNET') {
        modText = `${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.firstName ? booking.customer.firstName+' ' : ''}${booking.customer.lastName} ${this.formatDate(booking.createdAt)}`;
      } else if (status.uuid === 'STATUS_BOOKING_OFFER') {
        modText = `${commission.uuid === 'COMMISSION_OWNER' ? 'ET ' : ''}#${booking.offers[booking.offers.length-1].id} ${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.firstName ? booking.customer.firstName+' ' : ''}${booking.customer.lastName} ${this.formatDate(booking.offers[booking.offers.length-1].createdAt)}`;
      } else if (['STATUS_CONTRACT_SENT', 'STATUS_CONTRACT_RECEIVED'].includes(status.uuid)) {
        modText = `${commission.uuid === 'COMMISSION_OWNER' ? 'ET ' : ''}#${booking.parentContractId} ${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.firstName ? booking.customer.firstName+' ' : ''}${booking.customer.lastName} ${this.formatDate(booking.parentContract.createdAt)}`;
      } else {
        modText = `${commission.uuid === 'COMMISSION_OWNER' ? 'ET ' : ''}${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.firstName ? booking.customer.firstName+' ' : ''}${booking.customer.lastName}`;
      }
      return modText;
    }
  },
}
</script>

<style lang="scss" scoped>
.hover-wrapper {
  user-select: none;
  pointer-events: none;
  position: absolute;
  transform: translate(-50%, calc(-100% - 24px));
  background-color: $black;
  color: white;
  padding: 4px 12px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  z-index: 3;
  .ro-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .color-box {
    background-color: blueviolet;
    height: 14px;
    width: 20px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 3px;
  }
  .msg {
    white-space: nowrap;
  }
}
</style>